import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotFound from "../../pages/system/NotFound";
import { formatNumber, toValidNumber } from "../../utils/helpers";
import { AppDispatch, RootState } from "../../redux-stores/store";
import { fetchSocialPostThunk } from "../../redux-stores/slices/postsSlice";
import PostSkeleton from "../../skeletons/PostSkeleton";
import withSlideUpModal from "../../utils/hoc/withSlideUpModal";
import "./style.scss";

const ActionSquareTopDownIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 17.9167 17.9167" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.95833 1.76283e-07H8.91052C6.98686 -1.05526e-05 5.47933 -1.90487e-05 4.30309 0.158122C3.09914 0.319989 2.14912 0.657772 1.40345 1.40345C0.657772 2.14912 0.319989 3.09914 0.158122 4.30309C-1.90486e-05 5.47933 -1.05526e-05 6.98686 1.76283e-07 8.91052V9.00615C-1.05526e-05 10.9298 -1.90486e-05 12.4373 0.158122 13.6136C0.319989 14.8175 0.657772 15.7675 1.40345 16.5132C2.14912 17.2589 3.09914 17.5967 4.30309 17.7585C5.47933 17.9167 6.98686 17.9167 8.91052 17.9167H9.00614C10.9298 17.9167 12.4373 17.9167 13.6136 17.7585C14.8175 17.5967 15.7675 17.2589 16.5132 16.5132C17.2589 15.7675 17.5967 14.8175 17.7585 13.6136C17.9167 12.4373 17.9167 10.9298 17.9167 9.00614V8.95833C17.9167 8.61316 17.6368 8.33333 17.2917 8.33333C16.9465 8.33333 16.6667 8.61316 16.6667 8.95833C16.6667 10.9402 16.6653 12.3637 16.5197 13.447C16.3765 14.5124 16.104 15.1546 15.6293 15.6293C15.1546 16.104 14.5124 16.3765 13.447 16.5197C12.3637 16.6653 10.9402 16.6667 8.95833 16.6667C6.97648 16.6667 5.55296 16.6653 4.46965 16.5197C3.40431 16.3765 2.76204 16.104 2.28733 15.6293C1.81262 15.1546 1.54021 14.5124 1.39698 13.447C1.25133 12.3637 1.25 10.9402 1.25 8.95833C1.25 6.97648 1.25133 5.55296 1.39698 4.46965C1.54021 3.40431 1.81262 2.76204 2.28733 2.28733C2.76204 1.81262 3.40431 1.54021 4.46965 1.39698C5.55296 1.25133 6.97648 1.25 8.95833 1.25C9.30351 1.25 9.58333 0.970178 9.58333 0.625C9.58333 0.279822 9.30351 1.76283e-07 8.95833 1.76283e-07Z" fill="currentColor" />
        <path d="M9.34973 7.68306C9.10565 7.92714 9.10565 8.32286 9.34973 8.56694C9.5938 8.81102 9.98953 8.81102 10.2336 8.56694L16.6667 2.13388V5.07812C16.6667 5.4233 16.9465 5.70312 17.2917 5.70312C17.6368 5.70312 17.9167 5.4233 17.9167 5.07812V0.625C17.9167 0.279823 17.6368 1.76283e-07 17.2917 1.76283e-07H12.8385C12.4934 1.76283e-07 12.2135 0.279823 12.2135 0.625C12.2135 0.970178 12.4934 1.25 12.8385 1.25H15.7828L9.34973 7.68306Z" fill="currentColor" />
    </svg>
);

const LikeFilledIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.09712 3.49576C2.77368 2.81941 3.69117 2.43945 4.64782 2.43945C5.60448 2.43945 6.52197 2.81941 7.19853 3.49576C7.33081 3.62757 7.5011 3.7916 7.70939 3.98787C7.9172 3.7916 8.08724 3.62757 8.21953 3.49576C8.89325 2.8252 9.80439 2.44762 10.7549 2.44507C11.7055 2.44253 12.6187 2.81522 13.296 3.48217C13.9733 4.14911 14.36 5.05641 14.3721 6.00689C14.3842 6.95737 14.0207 7.87422 13.3606 8.55821L8.21881 13.7C8.0835 13.8353 7.9 13.9113 7.70867 13.9113C7.51734 13.9113 7.33384 13.8353 7.19853 13.7L2.05671 8.55893C1.39724 7.87879 1.03175 6.96655 1.03917 6.01921C1.0466 5.07188 1.42707 4.16548 2.09712 3.49576Z" fill="currentColor" />
    </svg>
);

const CommentFilledIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.50261 1.3327C3.82061 1.3327 0.835939 4.31736 0.835939 7.99936C0.835373 8.98162 1.05187 9.95186 1.46994 10.8407L0.849939 13.8654C0.827865 13.9734 0.832913 14.0851 0.864633 14.1907C0.896353 14.2963 0.953753 14.3923 1.0317 14.4703C1.10964 14.5482 1.20569 14.6056 1.31126 14.6373C1.41683 14.6691 1.52861 14.6741 1.63661 14.652L4.66127 14.032C5.52394 14.4387 6.48794 14.6654 7.50261 14.6654C11.1846 14.6654 14.1693 11.6814 14.1693 7.9987C14.1693 4.31736 11.1846 1.33203 7.50261 1.33203" fill="currentColor" />
    </svg>
);

const SendFilledIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 13.3333 14.2239" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2634 1.5241C13.5905 0.61922 12.7136 -0.257645 11.8088 0.0702328L0.749503 4.06989C-0.158408 4.39853 -0.268206 5.63734 0.567012 6.12121L4.09719 8.16496L7.24951 5.01263C7.39233 4.8747 7.5836 4.79838 7.78214 4.8001C7.98069 4.80183 8.17061 4.88146 8.311 5.02186C8.4514 5.16225 8.53104 5.35217 8.53276 5.55072C8.53449 5.74926 8.45816 5.94053 8.32023 6.08335L5.1679 9.23567L7.21241 12.7658C7.69552 13.6011 8.93434 13.4905 9.26297 12.5834L13.2634 1.5241Z" fill="currentColor" />
    </svg>
);

const EyeBoldIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 13.3333 10.6667" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.16667 5.33333C5.16667 4.50491 5.83824 3.83333 6.66667 3.83333C7.49509 3.83333 8.16667 4.50491 8.16667 5.33333C8.16667 6.16176 7.49509 6.83333 6.66667 6.83333C5.83824 6.83333 5.16667 6.16176 5.16667 5.33333Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 5.33333C0 6.42625 0.28331 6.79432 0.849929 7.53045C1.98131 9.0003 3.87874 10.6667 6.66667 10.6667C9.45459 10.6667 11.352 9.0003 12.4834 7.53045C13.05 6.79432 13.3333 6.42625 13.3333 5.33333C13.3333 4.24042 13.05 3.87235 12.4834 3.13622C11.352 1.66637 9.45459 0 6.66667 0C3.87874 0 1.98131 1.66637 0.849928 3.13622C0.283309 3.87235 0 4.24042 0 5.33333ZM6.66667 2.83333C5.28595 2.83333 4.16667 3.95262 4.16667 5.33333C4.16667 6.71405 5.28595 7.83333 6.66667 7.83333C8.04738 7.83333 9.16667 6.71405 9.16667 5.33333C9.16667 3.95262 8.04738 2.83333 6.66667 2.83333Z" fill="currentColor" />
    </svg>
);

const DiagramUpIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 14.3333 14.3333" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 0.5C1 0.223858 0.776143 0 0.5 0C0.223858 0 1.41027e-07 0.223858 1.41027e-07 0.5V7.20492C-8.44204e-06 8.74385 -1.52389e-05 9.94987 0.126498 10.8909C0.255991 11.854 0.526218 12.614 1.12276 13.2106C1.7193 13.8071 2.47931 14.0773 3.44247 14.2068C4.38346 14.3333 5.58949 14.3333 7.12842 14.3333H13.8333C14.1095 14.3333 14.3333 14.1095 14.3333 13.8333C14.3333 13.5572 14.1095 13.3333 13.8333 13.3333H7.16667C5.58118 13.3333 4.44237 13.3323 3.57572 13.2158C2.72345 13.1012 2.20964 12.8832 1.82986 12.5035C1.45009 12.1237 1.23217 11.6099 1.11758 10.7576C1.00106 9.89096 1 8.75215 1 7.16667V0.5Z" fill="currentColor" />
        <path d="M12.225 4.14427C12.3967 3.92802 12.3606 3.61351 12.1444 3.44178C11.9281 3.27005 11.6136 3.30614 11.4419 3.52239L9.36321 6.13999C9.1997 6.34588 9.09245 6.48051 9.00409 6.5775C8.91767 6.67236 8.87711 6.69927 8.85865 6.70914C8.71814 6.78425 8.55024 6.78791 8.40659 6.71897C8.38772 6.70991 8.34603 6.6848 8.25556 6.59378C8.16307 6.50073 8.05006 6.3709 7.87776 6.17231L7.86701 6.15991C7.70842 5.97713 7.57318 5.82125 7.45388 5.70123C7.32987 5.57646 7.19425 5.46006 7.02627 5.37945C6.59534 5.17265 6.09165 5.1836 5.67012 5.40895C5.50581 5.49679 5.37538 5.61897 5.25691 5.74901C5.14294 5.8741 5.01461 6.0357 4.86413 6.2252L2.77512 8.85572C2.60338 9.07196 2.63947 9.38648 2.85572 9.55822C3.07197 9.72995 3.38648 9.69386 3.55822 9.47761L5.63701 6.85997C5.80051 6.65408 5.90776 6.51946 5.99612 6.42248C6.08255 6.32762 6.12311 6.30071 6.14157 6.29084C6.28208 6.21573 6.44997 6.21208 6.59362 6.28101C6.61249 6.29007 6.65418 6.31519 6.74465 6.4062C6.83714 6.49925 6.95014 6.62908 7.12244 6.82766L7.13321 6.84008C7.29178 7.02285 7.42704 7.17874 7.54633 7.29875C7.67034 7.42352 7.80597 7.53992 7.97394 7.62053C8.40488 7.82734 8.90857 7.81638 9.33011 7.59103C9.49442 7.50319 9.62485 7.381 9.74332 7.25096C9.85728 7.12587 9.98559 6.96428 10.1361 6.77479L12.225 4.14427Z" fill="currentColor" />
    </svg>
);

const CreatorSocialPost: React.FC<{ selectedSocialPost: { socialPostId: string; socialAccountId: string } | null }> = ({ selectedSocialPost }) => {
    const dispatch: AppDispatch = useDispatch();

    const socialAccount = useSelector((state: RootState) => state.influencer.social_accounts.find((account) => account.social_account.uuid === selectedSocialPost?.socialAccountId));

    const postData = useSelector((state: RootState) =>
        selectedSocialPost ? state.posts.social_posts[selectedSocialPost.socialAccountId]?.[selectedSocialPost.socialPostId] : undefined
    );
    const post = postData?.post || null;
    const platform = postData?.post?.platform;
    const loading = useSelector((state: RootState) => state.posts.loading);

    const fetchSocialPost = useCallback(async () => {
        if (selectedSocialPost) {
            await dispatch(fetchSocialPostThunk({ socialPostId: selectedSocialPost.socialPostId, socialAccountId: selectedSocialPost.socialAccountId }));
        }
    }, [dispatch, selectedSocialPost]);

    useEffect(() => {
        fetchSocialPost();
    }, [selectedSocialPost, fetchSocialPost]);

    if (!selectedSocialPost) return <NotFound />;
    if (loading) return <PostSkeleton />;

    const captionText =
        platform === "ig"
            ? post?.ig?.caption || ""
            : platform === "yt"
                ? post?.yt?.title || ""
                : "";

    const likeCount = toValidNumber((post?.[platform as keyof typeof post] as any)?.like_count);
    const commentsCount = toValidNumber((post?.[platform as keyof typeof post] as any)?.comments_count);
    const viewsCount = toValidNumber((post?.[platform as keyof typeof post] as any)?.views_count);
    const sharesCount = toValidNumber((post?.[platform as keyof typeof post] as any)?.share_count);
    const reachCount = toValidNumber((post?.[platform as keyof typeof post] as any)?.reach_count);


    const likeCountFormatted = formatNumber(likeCount);
    const commentsCountFormatted = formatNumber(commentsCount);
    const viewsCountFormatted = formatNumber(viewsCount);
    const sharesCountFormatted = formatNumber(sharesCount);
    const reachCountFormatted = formatNumber(reachCount);

    return (
        <div className="creator-social-post">
            <div className="creator-social-post__media-shell">
                <div className="creator-social-post__media-frame">
                    {post?.ig ? (
                        post.ig?.media_url ? (
                            post.ig.media_type === "VIDEO" ? (
                                <video className="creator-social-post__media" src={post.ig.media_url} autoPlay controls />
                            ) : (
                                <img src={post.ig.media_url} className="creator-social-post__media" alt="Instagram media" />
                            )
                        ) : (
                            <a href={post.ig.permalink} target="_blank" rel="noopener noreferrer" className="creator-social-post__fallback-link">
                                View on Instagram
                            </a>
                        )
                    ) : post?.yt ? (
                        <iframe
                            src={post.yt.permalink ? `https://www.youtube.com/embed/${post.yt.permalink.split('/').pop()?.split('?')[0]}` : ""}
                            className="creator-social-post__media"
                            frameBorder={0}
                            allowFullScreen
                            title="YouTube video"
                        />
                    ) : null}
                </div>

                <button type="button" className="creator-social-post__share-btn" aria-label="Share">
                    <span className="creator-social-post__share-icon">
                        <ActionSquareTopDownIcon />
                    </span>
                </button>
            </div>

            <div className="creator-social-post__caption">
                <p className="creator-social-post__caption-text">
                    <span className="creator-social-post__handle">@{socialAccount?.social_account?.handle} </span>
                    <span style={{ whiteSpace: "pre-wrap" }}>{captionText}</span>
                </p>
                <p className="creator-social-post__posted-on">{post?.posted_on}</p>
            </div>
            {
                (likeCount > 0 || commentsCount > 0 || sharesCount > 0 || viewsCount > 0 || reachCount > 0) &&
                <div className="creator-social-post__analytics-card">
                    <p className="creator-social-post__analytics-title">Analytics</p>
                    {
                        likeCount > 0 &&
                        <div className="creator-social-post__metric-row">
                            <div className="creator-social-post__metric-left">
                                <span className="creator-social-post__metric-icon">
                                    <LikeFilledIcon />
                                </span>
                                <span className="creator-social-post__metric-label">Likes</span>
                            </div>
                            <span className="creator-social-post__metric-value">{likeCountFormatted}</span>
                        </div>
                    }


                    {
                        commentsCount > 0 &&
                        <div className="creator-social-post__metric-row">
                            <div className="creator-social-post__metric-left">
                                <span className="creator-social-post__metric-icon">
                                    <CommentFilledIcon />
                                </span>
                                <span className="creator-social-post__metric-label">Comments</span>
                            </div>
                            <span className="creator-social-post__metric-value">{commentsCountFormatted}</span>
                        </div>
                    }


                    {
                        sharesCount > 0 &&
                        <div className="creator-social-post__metric-row">
                            <div className="creator-social-post__metric-left">
                                <span className="creator-social-post__metric-icon">
                                    <SendFilledIcon />
                                </span>
                                <span className="creator-social-post__metric-label">Shares</span>
                            </div>
                            <span className="creator-social-post__metric-value">{sharesCountFormatted}</span>
                        </div>
                    }

                    {
                        viewsCount > 0 &&
                        <div className="creator-social-post__metric-row">
                            <div className="creator-social-post__metric-left">
                                <span className="creator-social-post__metric-icon">
                                    <EyeBoldIcon />
                                </span>
                                <span className="creator-social-post__metric-label">Views</span>
                            </div>
                            <span className="creator-social-post__metric-value">{viewsCountFormatted}</span>
                        </div>
                    }

                    {(platform === "ig" && reachCount > 0) ? (
                        <div className="creator-social-post__metric-row">
                            <div className="creator-social-post__metric-left">
                                <span className="creator-social-post__metric-icon">
                                    <DiagramUpIcon />
                                </span>
                                <span className="creator-social-post__metric-label">Reach</span>
                            </div>
                            <span className="creator-social-post__metric-value">{reachCountFormatted}</span>
                        </div>
                    ) : null}
                </div>
            }
        </div>
    );
};

export default withSlideUpModal(CreatorSocialPost, "", true, "creator-social-post");

